import React, { FC, RefObject } from 'react';
import { AllieChevronBackOutline, AllieChevronForward } from '../../../../../styling/icons';
import { ResizeCellContainer, ResizeCellControl } from './ResizeCell.styles';

const namespace = 'allie-resizable-box';

export interface ResizeCellProps {
  height: number;
  width: number;
  color: string;
}

export interface ResizeCellStateProps {
  isStart: boolean;
  isEnd: boolean;
  offsetLeft: number;
}

export const ResizeCell: FC<ResizeCellProps & ResizeCellStateProps> = ({
  height,
  width,
  isStart,
  isEnd,
  offsetLeft,
  color
}) => {
  const boxRef = React.useRef<HTMLDivElement>(null);

  return (
    <>
      <ResizeCellContainer
        ref={boxRef}
        className={namespace}
        style={{
          borderTopLeftRadius: isStart ? '4px' : '',
          borderBottomRightRadius: isEnd ? '4px' : '',
          left: `${offsetLeft}px`,
          backgroundColor: `var(--allie-color-${color})`,
          height,
          width,
        }}
      >
        <ResizeCellControl>
          {isStart && (
            <>
              <AllieChevronBackOutline />
              <div
                className={`${namespace}__control__pointer ${namespace}__control__pointer-w`}
              ></div>
            </>
          )}
        </ResizeCellControl>
        {isEnd && (
          <ResizeCellControl className={`${namespace}__control`}>
            <AllieChevronForward />
            <div
              className={`${namespace}__control__pointer ${namespace}__control__pointer-e`}
            ></div>
          </ResizeCellControl>
        )}
      </ResizeCellContainer>
    </>
  );
};
